import { Box, Typography, Button, Container } from "@mui/material";
import { useState } from "react";
import LuxuryPopup from "./LuxuryPopup";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";




const HeroSection = () => {

    const [open, setOpen] = useState(false);

    return (
        <>
            <Box
                sx={{
                    position: "relative",
                    height: { xs: "95vh", md: "100vh" }, // ✅ MOBILE FIX
                    backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/mandatehero1.png")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 2,
                }}
            >
                {/* OVERLAY */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        //             background: `
                        //   linear-gradient(
                        //     rgba(15,99,165,0.6),
                        //     rgba(15,99,165,0.6)
                        //   )
                        // `,
                    }}
                />

                <Container
                    maxWidth="xl"
                    sx={{
                        position: "relative",
                        textAlign: "start",
                        color: "#fff",
                    }}
                >
                    <Box
                        // maxWidth="800px"

                        sx={{
                            textAlign: "left",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            height: "100%",
                            mt: 16,
                            px: { xs: 1, lg: 10 },
                            maxWidth: { xs: "100%", md: "800px" },
                        }}
                    >

                        <Typography
                            variant="h1"
                            fontWeight={700}
                            lineHeight={1.2}
                            gutterBottom
                            sx={{
                                color: "white",
                                fontSize: { xs: "2.0rem", md: "3rem", lg: "2.1rem" },
                            }}
                        >
                            Transform Your Project's Sales Performance With
                            <span
                                style={{
                                    display: "block",
                                    fontSize: "3.8rem",
                                    fontWeight: 800,
                                }}
                            >
                                Structured Strategy
                            </span>
                        </Typography>


                        {/* Subheading */}
                        <Typography
                            variant="h1"
                            fontWeight={700}
                            lineHeight={1.2}
                            gutterBottom
                            sx={{
                                color: "#fff",
                                // fontWeight: 700,
                                mb: 2,
                                fontSize: { xs: "1.5rem", md: "2rem", lg: "1.7rem" },
                            }}
                        >
                            Expert Sales Consulting for
                            {/* <span
                                style={{
                                    display: "block",
                                    borderBottom: "4px solid #0080ff",
                                    width: "fit-content",
                                    paddingBottom: "4px",
                                    color: "#fff",
                                     fontWeight: 800,
                                    
                                    // fontSize: { xs: "1.5rem", md: "2rem", lg: "2rem" },

                                }}
                                
                            >
                                Luxury Real Estate Developers
                            </span> */}
                            <Box
                                component="span"
                                sx={{
                                    display: "block",
                                    borderBottom: "4px solid #0080ff",
                                    width: "fit-content",
                                    pb: "4px",
                                    color: "#fff",
                                    fontWeight: 800,
                                    fontSize: { xs: "1.8rem", md: "2rem", lg: "2rem" }, // ✅ FIX HERE
                                }}
                            >
                                Luxury Real Estate Developers
                            </Box>
                        </Typography>

                        {/* Subtitle */}
                        <Typography
                            variant="body1"
                            sx={{
                                opacity: 0.85,
                                mb: 4,
                                fontSize: "1.1rem",
                                color: "white",
                            }}
                        >
                            Most developers have a great product. What's missing is the system around it, the positioning, the process, and the people executing it right. I work directly with developer teams to fix what's slowing sales down and build something that holds.
                        </Typography>



                        {/* Buttons */}
                        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 1 }}>
                            {/* <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#C6A15B",
                                    color: "#111",
                                    fontFamily: "Inter",
                                    fontWeight: 500,
                                    textTransform: "none",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: "8px",
                                    boxShadow: "none",

                                    "&:hover": {
                                        backgroundColor: "#b8924f",
                                        boxShadow: "none",
                                    },
                                }}
                            >
                                Request Mandate Consultation
                            </Button> */}


                            <Button
                                // variant="outlined"
                                onClick={() => setOpen(true)} // ✅ OPEN POPUP
                                variant="contained"
                                endIcon={<ArrowForwardIcon />}
                                sx={{
                                    width: { xs: "100%", md: "fit-content" },
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: "30px",
                                    background:
                                        "linear-gradient(90deg, #0f63a5, #42a5f5)",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    boxShadow: "0 8px 30px rgba(15,99,165,0.4)",

                                    "&:hover": {
                                        transform: "translateY(-2px)",
                                    },
                                }}
                            >
                                Request a Sales Consultation
                            </Button>
                        </Box>

                        {/* BUTTON */}
                        {/* <Button
                            onClick={() => setOpen(true)} // ✅ OPEN POPUP
                            sx={{
                                background: "#fff",
                                color: "#0f63a5",
                                px: 4,
                                py: 1.5,
                                borderRadius: "30px",
                                textTransform: "none",
                            }}
                        >
                            Request Consultation
                        </Button> */}
                    </Box>

                </Container>
            </Box>

            {/* POPUP */}
            <LuxuryPopup open={open} onClose={() => setOpen(false)} />
        </>
    );
};

export default HeroSection;